
import React, { Component } from "react";

class TerrainGallery extends Component{

    constructor(props){
        super(props)
       
    }
    render(){
        const ars = [];
        console.log('############### this.props.tablets ****************')
        const tablets = this.props.tablets.map((l, k)=>{
            
            return (<figure>
                <img src={l} alt="Bluegrass" />

            </figure>);
        });


       
        return (

            <div className="svr-gal-content">
          
                <div className="gallery">
                   {tablets}
                </div>
            </div>
        )
    }
   
}

export default TerrainGallery;